import { gql } from '@apollo/client';

export const DELETE_INSIGHT_TAG = gql`
  mutation deleteInsightTag($input: UpsertInsightTagInput) {
    insightTag: deleteInsightTag(input: $input) {
      id
    }
  }
`;
